import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDHeadlineText } from '@facet-wealth/design';
import { Accordion } from 'Packages/FacetDesign/Components/Experimental/Accordion';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('esgDisclosure', {
    _component: () => Accordion,
  }, overrideReadOnly);
